import React from 'react';

import { CircularProgress, Table, TableBody, TableCell, TableRow } from '@material-ui/core';

const loadingCellStyle = {
  border: 'none',
  height: '50vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const centeredCellStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  whiteSpace: 'wrap',
  flexDirection: 'column',
  border: 'none',
};

const defaultCellStyle = {
  border: 'none',
};

export function TablePlaceholderRow({ colSpan, loading = false, centered = false, children }) {
  const cellStyle = loading ? loadingCellStyle : centered ? centeredCellStyle : defaultCellStyle;

  return (
    <TableRow>
      <TableCell colSpan={colSpan} style={cellStyle}>
        {loading ? <CircularProgress color='primary' /> : children}
      </TableCell>
    </TableRow>
  );
}

export default function TablePlaceholder({ colSpan = 6, loading = false, centered = false, children }) {
  return (
    <Table style={{ maxWidth: '100%' }}>
      <TableBody>
        <TablePlaceholderRow colSpan={colSpan} loading={loading} centered={centered}>
          {children}
        </TablePlaceholderRow>
      </TableBody>
    </Table>
  );
}
